
import { defineComponent } from 'vue'
import {SocialLink} from '@/components/atoms'

export default defineComponent({
  components: { SocialLink  }
})
